/* Load vendor logos asynchronously */
(function() {
	async function loadVendorLogo(vendorElement) {
		const vendorName = vendorElement.getAttribute('data-vendor');
		if (!vendorName) return;

		const vendorLink = vendorElement.querySelector('.product__vendor-link');
		const vendorPrefix = vendorElement.querySelector('.product__vendor-prefix');
		if (!vendorLink) return;

		try {
			const encodedVendor = encodeURIComponent(vendorName);
			const response = await fetch(`https://sync.craftdepot.de/brands/${encodedVendor}`);

			if (!response.ok) {
				// API failed - show text fallback
				showTextFallback(vendorElement, vendorLink, vendorPrefix);
				return;
			}

			const data = await response.json();

			if (data.logos && data.logos.medium) {
				// Logo exists - remove prefix and show only logo
				if (vendorPrefix) {
					vendorPrefix.remove();
				}

				const img = document.createElement('img');
				img.alt = vendorName;
				img.style.maxHeight = '24px';
				img.style.height = 'auto';
				img.style.width = 'auto';
				img.style.objectFit = 'contain';
				img.style.display = 'block';

				// Show image only after it's fully loaded
				img.onload = function() {
					vendorLink.innerHTML = '';
					vendorLink.appendChild(img);
					vendorLink.style.visibility = 'visible';
				};

				// Fallback: if image fails to load, show text
				img.onerror = function() {
					if (vendorPrefix) {
						vendorElement.insertBefore(vendorPrefix, vendorLink);
					}
					vendorLink.innerHTML = vendorName;
					showTextFallback(vendorElement, vendorLink, vendorPrefix);
				};

				// Start loading the image
				img.src = data.logos.medium;
			} else {
				// No logo - show text fallback
				showTextFallback(vendorElement, vendorLink, vendorPrefix);
			}
		} catch (error) {
			// Error - show text fallback
			console.debug('Failed to load vendor logo:', error);
			showTextFallback(vendorElement, vendorLink, vendorPrefix);
		}
	}

	function showTextFallback(vendorElement, vendorLink, vendorPrefix) {
		// Show both prefix and vendor name
		if (vendorPrefix) {
			vendorPrefix.style.visibility = 'visible';
		}
		vendorLink.style.visibility = 'visible';
	}

	// Load logos after page load to not block rendering
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function() {
			setTimeout(function() {
				document.querySelectorAll('.product__text-vendor').forEach(loadVendorLogo);
			}, 100);
		});
	} else {
		setTimeout(function() {
			document.querySelectorAll('.product__text-vendor').forEach(loadVendorLogo);
		}, 100);
	}
})();
